@let os = deviceService.osName;

<p-dialog
  class="dialog-primary full headless dialog-content-flex dialog-content-grow-1"
  [visible]="isOpened()"
  (visibleChange)="close()"
  [modal]="true"
>
  <div class="flex-wrapper">
    <header>
      <app-icon-close
        (click)="close()"
        [width]="24"
        [height]="24"
        [color]="'var(--color-gray-900)'"
      ></app-icon-close>
    </header>
    <section class="content">
      @if (
        {
          currentLang: languageService.current$ | async,
          branding: brandingService.branding$ | async,
        };
        as view
      ) {
        @switch (os) {
          @case ('Android') {
            @switch (step()) {
              @case (1) {
                <ng-container
                  [ngTemplateOutlet]="step1AndroidRef"
                  [ngTemplateOutletContext]="{ currentLang: view.currentLang }"
                ></ng-container>
              }
              @case (2) {
                <ng-container
                  [ngTemplateOutlet]="step2AndroidRef"
                  [ngTemplateOutletContext]="{ currentLang: view.currentLang }"
                ></ng-container>
              }
              @case (3) {
                <ng-container
                  [ngTemplateOutlet]="step3AndroidRef"
                  [ngTemplateOutletContext]="{ currentLang: view.currentLang }"
                ></ng-container>
              }
              @case (4) {
                <ng-container
                  [ngTemplateOutlet]="step4AndroidRef"
                  [ngTemplateOutletContext]="{
                    currentLang: view.currentLang,
                    branding: view.branding,
                  }"
                ></ng-container>
              }
              @case (5) {
                <ng-container
                  [ngTemplateOutlet]="step5AndroidRef"
                  [ngTemplateOutletContext]="{
                    currentLang: view.currentLang,
                    branding: view.branding,
                  }"
                ></ng-container>
              }
              @case (6) {
                <ng-container
                  [ngTemplateOutlet]="step6AndroidRef"
                  [ngTemplateOutletContext]="{ branding: view.branding }"
                ></ng-container>
              }
            }
          }
          @case ('iOS') {
            @switch (step()) {
              @case (1) {
                <ng-container
                  [ngTemplateOutlet]="step1iOSRef"
                  [ngTemplateOutletContext]="{ currentLang: view.currentLang }"
                ></ng-container>
              }
              @case (2) {
                <ng-container
                  [ngTemplateOutlet]="step2iOSRef"
                  [ngTemplateOutletContext]="{ currentLang: view.currentLang }"
                ></ng-container>
              }
              @case (3) {
                <ng-container
                  [ngTemplateOutlet]="step3iOSRef"
                  [ngTemplateOutletContext]="{ currentLang: view.currentLang }"
                ></ng-container>
              }
              @case (4) {
                <ng-container
                  [ngTemplateOutlet]="step4iOSRef"
                  [ngTemplateOutletContext]="{
                    currentLang: view.currentLang,
                    branding: view.branding,
                  }"
                ></ng-container>
              }
              @case (5) {
                <ng-container
                  [ngTemplateOutlet]="step5iOSRef"
                  [ngTemplateOutletContext]="{ branding: view.branding }"
                ></ng-container>
              }
            }
          }
        }
      }

      <section class="footer">
        @if (step() !== 1) {
          <p-button
            [severity]="'secondary'"
            (click)="stepperFunction(step() - 1)"
            class="cancel w100 p--18 w50 h--40 text-14 fw-600"
          >
            {{ 'button.back' | translate }}
          </p-button>
        }
        @switch (step()) {
          @case (5) {
            @if (os === 'iOS') {
              <p-button class="w100 h--40 text-14 fw-600" (click)="close()">
                {{ 'button.close' | translate }}
              </p-button>
            } @else if (os === 'Android') {
              <p-button class="w100 h--40 text-14 fw-600" (click)="stepperFunction(step() + 1)">
                {{ 'button.continue' | translate }}
              </p-button>
            }
          }
          @case (6) {
            <p-button class="w100 h--40 text-14 fw-600" (click)="close()">
              {{ 'button.close' | translate }}
            </p-button>
          }
          @default {
            <p-button class="w100 h--40 text-14 fw-600" (click)="stepperFunction(step() + 1)">
              {{ 'button.continue' | translate }}
            </p-button>
          }
        }
      </section>
    </section>
  </div>
</p-dialog>

<ng-template #step1iOSRef let-currentLang="currentLang">
  <div class="image-container mt-24">
    <img
      class="preview"
      [src]="
        currentLang === 'es'
          ? './assets/images/pwa-install-guide/preview-1-ios-es.png'
          : './assets/images/pwa-install-guide/preview-1-ios-en.png'
      "
      alt=""
    />
    <div class="horizontal-spacer mb-24"></div>
  </div>
  <div class="content-wrapper">
    <div class="caption">{{ 'pwa-install-guide.install-mobile-app' | translate }}</div>
    <div class="description">
      {{ 'pwa-install-guide.quick-access' | translate }}
    </div>
  </div>
</ng-template>

<ng-template #step1AndroidRef let-currentLang="currentLang">
  <div class="image-container mt-24">
    <img
      class="preview"
      [src]="
        currentLang === 'es'
          ? './assets/images/pwa-install-guide/preview-1-chrome-android-es.png'
          : './assets/images/pwa-install-guide/preview-1-chrome-android-en.png'
      "
      alt=""
    />
    <div class="horizontal-spacer mb-24"></div>
  </div>
  <div class="content-wrapper">
    <div class="caption">{{ 'pwa-install-guide.install-mobile-app' | translate }}</div>
    <div class="description">
      {{ 'pwa-install-guide.quick-access' | translate }}
    </div>
  </div>
</ng-template>

<ng-template #step2iOSRef let-currentLang="currentLang">
  <div class="image-container step-2 mt-24 mb-24">
    @switch (deviceService.browserName) {
      @case ('Chrome') {
        <img
          class="preview"
          [src]="
            currentLang === 'es'
              ? './assets/images/pwa-install-guide/preview-2-chrome-es.webp'
              : './assets/images/pwa-install-guide/preview-2-chrome-en.webp'
          "
          alt=""
        />
        <div class="custom-url chrome">
          <div class="text">{{ baseUrl() | clearBaseUrl }}</div>
        </div>

        <img
          class="arrow chrome"
          [src]="'./assets/images/pwa-install-guide/preview-arrow.webp'"
          alt=""
        />
      }
      @case ('Safari') {
        <img
          class="preview"
          [src]="
            currentLang === 'es'
              ? './assets/images/pwa-install-guide/preview-2-safari-es.webp'
              : './assets/images/pwa-install-guide/preview-2-safari-en.webp'
          "
          alt=""
        />
        <div class="custom-url safari">
          <div class="text">{{ baseUrl() | clearBaseUrl }}</div>
        </div>

        <img
          class="arrow safari"
          [src]="'./assets/images/pwa-install-guide/preview-arrow.webp'"
          alt=""
        />
      }
    }
  </div>
  <div class="content-wrapper">
    <div class="download-card">
      <span class="description text">
        {{ 'pwa-install-guide.tap-on' | translate }}

        <app-icon-safari-symbol
          class="icon"
          [width]="15"
          [height]="18"
          [color]="'#0657DA'"
        ></app-icon-safari-symbol>

        {{
          'pwa-install-guide.button-in-browser' | translate: { message: deviceService.browserName }
        }}
      </span>
    </div>
  </div>
</ng-template>

<ng-template #step2AndroidRef let-currentLang="currentLang">
  <div class="image-container step-2 android mt-24 mb-24">
    <img
      class="preview"
      [src]="
        currentLang === 'es'
          ? './assets/images/pwa-install-guide/preview-2-chrome-android-es.png'
          : './assets/images/pwa-install-guide/preview-2-chrome-android-en.png'
      "
      alt=""
    />
    <div class="custom-url chrome">
      <div class="text">{{ baseUrl() | clearBaseUrl }}</div>
    </div>
  </div>
  <div class="content-wrapper step-2 android">
    <div class="download-card">
      <span class="description text">
        {{ 'pwa-install-guide.tap-on' | translate }}

        <i class="pi pi-ellipsis-v"></i>

        {{
          'pwa-install-guide.button-in-browser' | translate: { message: deviceService.browserName }
        }}
      </span>
    </div>
  </div>
</ng-template>

<ng-template #step3iOSRef let-currentLang="currentLang">
  <div class="image-container step-3 mt-24 mb-24">
    @switch (deviceService.browserName) {
      @case ('Chrome') {
        <img
          class="preview"
          [src]="
            currentLang === 'es'
              ? './assets/images/pwa-install-guide/preview-3-chrome-es.png'
              : './assets/images/pwa-install-guide/preview-3-chrome-en.png'
          "
          alt=""
        />
      }
      @case ('Safari') {
        <img
          class="preview"
          [src]="
            currentLang === 'es'
              ? './assets/images/pwa-install-guide/preview-3-safari-es.png'
              : './assets/images/pwa-install-guide/preview-3-safari-en.png'
          "
          alt=""
        />
      }
    }
  </div>
  <div class="content-wrapper step-3">
    <div class="download-card">
      <span class="description text">
        <span>{{ 'pwa-install-guide.select' | translate }}</span>
        <span class="link">
          {{
            (deviceService.browserName === 'Safari'
              ? 'pwa-install-guide.add-to-home-screen'
              : 'pwa-install-guide.add-to-home-screen-chrome'
            ) | translate
          }}
        </span>
      </span>
    </div>
  </div>
</ng-template>

<ng-template #step3AndroidRef let-currentLang="currentLang">
  <div class="image-container step-3 android mt-24 mb-24">
    <img
      class="preview"
      [src]="
        currentLang === 'es'
          ? './assets/images/pwa-install-guide/preview-3-chrome-android-es.png'
          : './assets/images/pwa-install-guide/preview-3-chrome-android-en.png'
      "
      alt=""
    />
  </div>
  <div class="content-wrapper step-3 android">
    <div class="download-card">
      <span class="description text">
        <span>{{ 'pwa-install-guide.select' | translate }}</span>
        <span class="link">
          {{ 'pwa-install-guide.add-to-home-screen' | translate }}
        </span>
      </span>
    </div>
  </div>
</ng-template>

<ng-template #step4iOSRef let-currentLang="currentLang" let-branding="branding">
  <div class="image-container mt-24 mb-24">
    <img
      class="preview"
      [src]="
        currentLang === 'es'
          ? './assets/images/pwa-install-guide/preview-4-safari-es.webp'
          : './assets/images/pwa-install-guide/preview-4-safari-en.webp'
      "
      alt=""
    />
    @if (branding) {
      <div class="custom-logo">
        <img [src]="branding?.logo?.sm?.href" alt="" />
      </div>
      <div class="custom-name">
        {{ branding?.name }}
      </div>
      <div class="custom-url">{{ baseUrl() | clearBaseUrl }}</div>
    }
    <div class="horizontal-spacer"></div>
  </div>
  <div class="content-wrapper">
    <div class="download-card">
      <span class="description text">
        {{ 'pwa-install-guide.choose-name' | translate }}
      </span>
    </div>
  </div>
</ng-template>

<ng-template #step4AndroidRef let-currentLang="currentLang" let-branding="branding">
  <div class="image-container step-4 android mt-24 mb-24">
    <img
      class="preview"
      [src]="
        currentLang === 'es'
          ? './assets/images/pwa-install-guide/preview-4-chrome-android-es.png'
          : './assets/images/pwa-install-guide/preview-4-chrome-android-en.png'
      "
      alt=""
    />
    @if (branding) {
      <div class="custom-logo install">
        <img [src]="branding?.logo?.sm?.href" alt="" />
      </div>

      <div class="custom-logo shortcut">
        <img [src]="branding?.logo?.sm?.href" alt="" />
      </div>

      <div class="svg svg-custom install">
        <app-icon-arrow
          [width]="14"
          [height]="14"
          [direction]="'down'"
          [color]="'#1D2024'"
        ></app-icon-arrow>
      </div>

      <svg
        class="svg shortcut"
        width="18"
        height="18"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_37_9904)">
          <path
            d="M7.38161 11.0706C9.41993 11.0706 11.0723 9.41822 11.0723 7.3799C11.0723 5.34159 9.41993 3.68921 7.38161 3.68921C5.3433 3.68921 3.69092 5.34159 3.69092 7.3799C3.69092 9.41822 5.3433 11.0706 7.38161 11.0706Z"
            fill="white"
          />
          <path
            d="M7.38114 3.69071H13.7726C13.1249 2.56855 12.1932 1.63668 11.0712 0.988814C9.94914 0.340945 8.67631 -9.03822e-05 7.38066 1.79675e-08C6.08501 9.04181e-05 4.81222 0.341303 3.69027 0.989329C2.56832 1.63735 1.63676 2.56935 0.989258 3.6916L4.18497 9.22675L4.18783 9.22602C3.86274 8.66542 3.69119 8.02903 3.69046 7.38099C3.68973 6.73296 3.85985 6.09618 4.18368 5.53486C4.50751 4.97353 4.9736 4.5075 5.53496 4.18373C6.09632 3.85997 6.73311 3.68991 7.38114 3.69071Z"
            fill="url(#paint0_linear_37_9904)"
          />
          <path
            d="M7.38127 10.3031C8.99494 10.3031 10.3031 8.99494 10.3031 7.38127C10.3031 5.76761 8.99494 4.45947 7.38127 4.45947C5.76761 4.45947 4.45947 5.76761 4.45947 7.38127C4.45947 8.99494 5.76761 10.3031 7.38127 10.3031Z"
            fill="#1A73E8"
          />
          <path
            d="M10.5769 9.22763L7.38121 14.7628C8.67685 14.763 9.94971 14.422 11.0718 13.7742C12.1939 13.1264 13.1256 12.1947 13.7734 11.0725C14.4211 9.95043 14.762 8.67756 14.7618 7.38192C14.7615 6.08628 14.4202 4.81353 13.772 3.69165H7.38065L7.37988 3.69451C8.02792 3.69326 8.66483 3.86288 9.22642 4.18626C9.788 4.50964 10.2544 4.97536 10.5786 5.53647C10.9028 6.09758 11.0734 6.73424 11.0731 7.38228C11.0728 8.03032 10.9016 8.66682 10.5769 9.22763Z"
            fill="url(#paint1_linear_37_9904)"
          />
          <path
            d="M4.18541 9.22766L0.989693 3.6925C0.341706 4.81448 0.000536571 6.08728 0.000488286 7.38293C0.000440001 8.67858 0.341515 9.9514 0.989418 11.0734C1.63732 12.1954 2.56921 13.1271 3.69139 13.7747C4.81357 14.4224 6.08648 14.7631 7.38213 14.7627L10.5778 9.22759L10.5758 9.2255C10.2528 9.78734 9.78749 10.2541 9.22663 10.5788C8.66578 10.9034 8.02925 11.0745 7.38122 11.0747C6.73318 11.0749 6.09654 10.9043 5.53547 10.58C4.9744 10.2557 4.50873 9.78927 4.18541 9.22766Z"
            fill="url(#paint2_linear_37_9904)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_37_9904"
            x1="0.989258"
            y1="4.61338"
            x2="13.7726"
            y2="4.61338"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#D93025" />
            <stop offset="1" stop-color="#EA4335" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_37_9904"
            x1="6.37278"
            y1="14.6641"
            x2="12.7645"
            y2="3.59342"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FCC934" />
            <stop offset="1" stop-color="#FBBC04" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_37_9904"
            x1="8.18043"
            y1="14.3019"
            x2="1.78876"
            y2="3.23117"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#1E8E3E" />
            <stop offset="1" stop-color="#34A853" />
          </linearGradient>
          <clipPath id="clip0_37_9904">
            <rect width="14.7628" height="14.7628" fill="white" />
          </clipPath>
        </defs>
      </svg>
    }
    <div class="horizontal-spacer"></div>
  </div>
  <div class="content-wrapper step-4 android">
    <div class="download-card">
      <span class="description text">
        {{ 'pwa-install-guide.click-on-install' | translate }}
      </span>
    </div>
  </div>
</ng-template>

<ng-template #step5iOSRef let-branding="branding">
  <div class="image-container mt-24 mb-24">
    <img
      class="preview"
      [src]="'./assets/images/pwa-install-guide/preview-5-safari-en.webp'"
      alt=""
    />
    @if (branding) {
      <div class="custom-logo phone-screen">
        <img [src]="branding?.logo?.sm?.href" alt="" />
      </div>
      <div class="custom-name phone-screen">
        {{ branding?.name }}
      </div>
    }
    <div class="horizontal-spacer"></div>
  </div>
  <div class="content-wrapper">
    <div class="download-card">
      <span class="description text"> {{ 'pwa-install-guide.find-place' | translate }} </span>
    </div>
  </div>
</ng-template>

<ng-template #step5AndroidRef let-currentLang="currentLang" let-branding="branding">
  <div class="image-container step-5 android mt-24 mb-24">
    <img
      class="preview"
      [src]="
        currentLang === 'es'
          ? './assets/images/pwa-install-guide/preview-5-chrome-android-es.png'
          : './assets/images/pwa-install-guide/preview-5-chrome-android-en.png'
      "
      alt=""
    />
    @if (branding) {
      <div class="custom-logo">
        <img [src]="branding?.logo?.sm?.href" alt="" />
      </div>
      <div class="custom-name">
        {{ branding?.name }}
      </div>
      <div class="custom-url">
        <div class="text">{{ baseUrl() | clearBaseUrl }}</div>
      </div>

      <div class="svg svg-custom install">
        <app-icon-arrow
          [width]="14"
          [height]="14"
          [direction]="'down'"
          [color]="'#1D2024'"
        ></app-icon-arrow>
      </div>
    }
    <div class="horizontal-spacer"></div>
  </div>
  <div class="content-wrapper step-5 android">
    <div class="download-card">
      <span class="description text"> {{ 'pwa-install-guide.click-on-install' | translate }} </span>
    </div>
  </div>
</ng-template>

<ng-template #step6AndroidRef let-branding="branding">
  <div class="image-container step-6 android mt-24 mb-24">
    <img
      class="preview"
      [src]="'./assets/images/pwa-install-guide/preview-6-chrome-android-en.webp'"
      alt=""
    />
    @if (branding) {
      <div class="custom-logo phone-screen">
        <img [src]="branding?.logo?.sm?.href" alt="" />
      </div>
      <div class="custom-name phone-screen">
        {{ branding?.name }}
      </div>
    }
    <div class="horizontal-spacer"></div>
  </div>
  <div class="content-wrapper step-6 android">
    <div class="download-card">
      <span class="description text"> {{ 'pwa-install-guide.find-place' | translate }} </span>
    </div>
  </div>
</ng-template>
